export default __webpack_public_path__ + "static/media/basketballing.a7a5ade2.png";